export default __webpack_public_path__ + "static/media/karpov.abbda041.txt";